import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import { AppContext, DispatchContext } from "../../AppContext";
import ReportOverViewComponent from "../../containers/ReportOverview/ReportOverview";
import ReportReviewComponent from "../../containers/ReportReview/ReportReview";
import Service from "../../services/service";
import * as actions from "../../actions/actions";
import ReactTooltip from "react-tooltip";
import DownloadReportDialog from "../../components/DownloadReportDialog";
import TitleBar from "../../containers/Layout/TitleBar";
import {CircularProgress, Typography} from '@material-ui/core';
import { resolveNotificationMessage } from '../../helpers/constants';
import ConfirmationDialog from "../../components/ConfirmationDialog";





const useStyles = makeStyles((theme) => ({
  loading: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100vh",
    background: theme.palette.background.image,
    backgroundSize: "cover",
    padding: theme.spacing(2),
    justifyContent: "center",
    alignItems: "center",
    color: "white"
  },
  error: {
    flex: "0 0 auto",
    alignSelf: "center",
    justifySelf: "center",
  },
  root: {
    height: "100vh",
    display: "flex",
    flex: "0 0 auto",
    flexDirection: "column",
  },
  paMain: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "row",
  },
  paCenter: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    background: theme.palette.background.image,
    backgroundSize: 'cover',
  },
  paAppBar: {
    zIndex: 10,
  },
  paBottomBar: {
    height: 40,
  },
  paCenterHeader: {
    display: "flex",
    height: '50px',
    backgroundColor: "#eeeeee",
    alignItems: "center",
    margin: "0",
    padding: '0px 15px',
    zIndex: 5,
    boxShadow: "0px 0px 0px 2px rgba(0, 0, 0, 0.2)",
  },
  paCenterHeaderIcon: {
    marginLeft: 'auto',
    textAlign: 'end',
    width: 100
  },
  icon_block: {
    "font-size": "18px",
    "margin": "0 5px"
  },
  title_head: {
    paddingLeft: "15px",
    display: "contents",
    fontSize: "18px",
  },
  cursor_pointer: {
    cursor: 'pointer'
  },
  tooltip: {
    zIndex: 5000,
    position: "absolute",
    fontSize: "12px",
    padding: 5,
  }
}));

export default function AppGrid(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles(state);
  const { id } = useParams();
  const { action } = useParams();
  const [loading, setLoading] = useState(true);
  const [noAccess, setNoAccess] = useState(true);
  const [resultMessage, setResultMessage] = useState(null);


  useEffect(() => {
    ReactTooltip.rebuild();
  });

  useEffect(() => {

    if (!state.activeReportId) {
      Service.resolvePermaLink(id, action).then(res => {
        setLoading(false);
        if (res.success && res.data) {
          if (res.data.Type == "report") {
            dispatch(actions.setUI({ ...state.ui, permaLinkId: id }));
            dispatch(actions.change_report_card(res.data.ReportId));
            setNoAccess(false);
          } else if (res.data.Type == "approval") {
            setResultMessage(res.message);
            setNoAccess(false);
          } else {
            setNoAccess(true);  
          } 
        } else {
          setNoAccess(true);
          if (res.errors && res.errors[0]) {
            setResultMessage(resolveNotificationMessage(res.errors[0], s.notificationMessage));
          }
        }
      });
    }
  }, []);

  if (loading) {
    return (<div className={classes.loading}>
      <CircularProgress color="inherit" />
      <p>{s.loadingReport}</p>
    </div>);
  } else if (noAccess) {
    return (
      <div className={classes.loading}>
        <Typography align="center" variant="h5" paragraph>{s.noAccess}</Typography>
        {resultMessage ?
        <Typography align="center" variant="body1" paragraph>{resultMessage}</Typography> :
        <Typography align="center" variant="body1" paragraph>{s.notificationMessage.permalinkNotValid}</Typography> }
      </div>
    )
  } else if (resultMessage) {
    return (
      <div className={classes.loading}>
        <Typography align="center" variant="h5" paragraph>{resolveNotificationMessage(resultMessage, s.notificationMessage)}</Typography>
        <Typography align="center" variant="body1" paragraph>{s.notificationMessage.closeWindowHint}</Typography>
      </div>
    )
  }

 

  return (
    <>
      <DownloadReportDialog />
      <ConfirmationDialog />
      <ReactTooltip id="globalTT" effect="solid" place="top" delayShow={500} className={classes.tooltip} />
      <ReactTooltip id="compareTT" html={true} place="top" className={classes.tooltip}/>
      <ReactTooltip id="sourceTT" html={true} place="top" className={classes.tooltip} />

      <div className={classes.root}>
        <div className={classes.paAppBar}>
          <TitleBar />
        </div>
        <div className={classes.paMain}>
          <div className={classes.paCenter}>
            <ReportReviewComponent />
          </div>
        </div>
      </div>
    </>
  );
}
